import { useState } from 'react'

import { CustomSeoDetail, Image, Post } from '@tribeplatform/gql-client/types'

type usePostSeoDetailHook = (options: { isNew: boolean; post: Post }) => {
  seoDetail: CustomSeoDetail
  setSeoDetail: (
    key: 'title' | 'description' | 'thumbnail',
    value: Image | string | undefined,
  ) => void
}
export const usePostSeoDetail: usePostSeoDetailHook = ({ post }) => {
  const [seoDetail, setSeoDetail] = useState<CustomSeoDetail>(
    post?.customSeoDetail,
  )

  return {
    seoDetail,
    setSeoDetail: (key, value) => {
      const payload = {
        ...seoDetail,
        [key]: value,
      }
      if (key === 'thumbnail') {
        payload.thumbnailId = (value as Image)?.id
      }
      setSeoDetail(payload)
    },
  }
}
